// Angular imports
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

// CC-Common imports
import { IconConstants } from 'cc-common';

// Third party imports
import { DxFormComponent } from 'devextreme-angular';
import notify from 'devextreme/ui/notify';

// Constant imports
import { StringFormatConstants } from '../../../../../_constants/string-format-constants';
import { MessageInterval } from '../../../../../_constants/messages-intervals';
import { Constants } from '../../../../../_constants/constants';

// Service imports
import { ServerErrorService } from '../../../../../_services/shared-services/server-error.service';
import { ARPaymentService } from '../../../_services/account-receivable/ar-payment.service';
import { PrecisionService } from '../../../../../_services/shared-services/precision.service';

// Model imports
import { ARPaymentParameterDto } from '../../../_models/account-receivable/ar-payment/ar-payment-parameter-dto';
import { ARPaymentIssueRefundEditorResultDto } from '../../../_models/account-receivable/ar-payment/ar-payment-issue-refund-editor-result-dto';
import { ARPaymentIssueRefundRawDto } from '../../../_models/account-receivable/ar-payment/ar-payment-issue-refund-raw-dto';

@Component({
    selector: 'app-issue-refund-payment-editor',
    templateUrl: './issue-refund-payment-editor.component.html',
    styleUrls: ['./issue-refund-payment-editor.component.scss']
})
export class IssueRefundPaymentEditorComponent implements OnInit {
    @ViewChild('issueRefundEditorForm', { static: false }) issueRefundEditorForm: DxFormComponent;
    @Input() visible = false;
    @Input() arPaymentParam: ARPaymentParameterDto;
    @Output() onIssueRefundEditorClose = new EventEmitter<boolean>();

    loadingVisible = false;
    defaultLabelLocation: string = Constants.defaultFormLabelLocation;
    currencyFormat: any;

    saveIcon: string = IconConstants.SAVE;
    closeIcon: string = IconConstants.CLOSE;

    issueRefundEditorData: ARPaymentIssueRefundEditorResultDto;
    issueRefundInfo: ARPaymentIssueRefundRawDto;

    constructor(
        private readonly arPaymentService: ARPaymentService,
        private readonly errorService: ServerErrorService,
        private readonly precisionService: PrecisionService
    ) {
        this.currencyFormat = this.precisionService.updatePrecisionPoint(StringFormatConstants.currencyFormat);
    }

    ngOnInit() {
        if (!!this.arPaymentParam) {
            this.populateIssueRefundEditor();
        }
    }

    onHidden(e): void {
        this.visible = false;
        this.onIssueRefundEditorClose.emit(e);
    }

    onSaveClick(): void {
        const validate = this.issueRefundEditorForm.instance.validate();
        if (validate.isValid) {
            this.loadingVisible = true;
            this.arPaymentService.updateARIssueRefundPaymentEditor(this.issueRefundInfo).subscribe(
                () => {
                    notify('Successfully applied refund ', 'success', MessageInterval.successMsgInterval);
                    this.onHidden(true);
                    this.loadingVisible = false;
                },
                (error) => {
                    this.loadingVisible = false;
                    this.errorService.displayError(error);
                    this.onHidden(false);
                }
            );
        }
    }

    private populateIssueRefundEditor(): void {
        this.loadingVisible = true;
        this.arPaymentService.getARIssueRefundPaymentEditor(this.arPaymentParam).subscribe(
            (result) => {
                this.issueRefundEditorData = result;
                this.issueRefundInfo = result.issueRefundInfo;
                this.loadingVisible = false;
            },
            (error) => {
                this.loadingVisible = false;
                this.errorService.displayError(error);
                this.onHidden(true);
            }
        );
    }
}
